import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import {
    Card,
    CardContent,
    Typography,
    Grid,
    Container,
    Box, CardMedia, Button, TextField, InputAdornment
} from '@material-ui/core';
import '../assets/styles/SmartReportPage.css';
import SearchIcon from "@material-ui/icons/Search";
import {useReports} from "./ReportContext";
import Breadcrumb from "./BreadcrumbsComponent";
import ComingSoon from "./ComingSoon";

const SmartReportPage = (comingSoon=true) => {

    const [searchTerm, setSearchTerm] = useState('');

    const { reports } = useReports();


    // const reportFiles = [
    //     { title: 'Report 1', imagePath: require('../assets/images/CMA_or_Report_1.png') },
    //     { title: 'Report 2', imagePath: require('../assets/images/CMA_or_Report_2.png') },
    //     { title: 'Report 3', imagePath: require('../assets/images/CMA_or_Report_3.png') },
    // ];

    const filteredReports = reports.filter(report => {
        const titleMatch = report.title.toLowerCase().includes(searchTerm.toLowerCase());
        // Add more conditions as required, like filtering by address, client, etc.
        return titleMatch;
    });

    return (
        <Container>
            <Grid container spacing={3}>

                <Breadcrumb />

                <Grid item xs={12}>
                    <Typography variant="h4" className="header-title-left">Smart Reports</Typography>
                    {/*<hr className="horizontal-line" />*/}
                </Grid>


                {!comingSoon && <Grid item xs={12}>
                    <Grid container spacing={3} justifyContent="center">
                        <Grid item xs={12} md={4}>
                            <Link to="/smart-reports/new-smart-report" className="no-underline-link">
                                <Card className="report-card">
                                    <CardContent>
                                        <Typography variant="h5" align="center">Seller Report</Typography>
                                    </CardContent>
                                </Card>
                            </Link>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Card className="report-card">
                                <CardContent>
                                    <Typography variant="h5" align="center">Buyer Report</Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Card className="report-card">
                                <CardContent>
                                    <Typography variant="h5" align="center">CMA Report</Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>}
                 {comingSoon && <ComingSoon />}
            </Grid>



            {!comingSoon && <>
                <Grid item xs={12}>
                    <Typography variant="h4" align="left" className="header-title">Recently Created Smart Reports</Typography>
                </Grid>

                <Grid item xs={12} style={{marginBottom: "5px"}}>
                    <Box position="relative" className="report-search" mt={3}> {/* Added spacing from the cards above using mt (marginTop) */}
                        <TextField
                            variant="standard"
                            placeholder="Search by report name or client..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={3}>
                        {filteredReports.map(report => (
                            // <Grid item xs={12} md={4} key={report.title}>
                            //     <Card className="cma-card">
                            //         <Grid container>
                            //             <Grid item xs={5}>
                            //                 <CardMedia
                            //                     component="img"
                            //                     alt={report.title}
                            //                     height="140"
                            //                     image={report.image}
                            //                     title={report.title}
                            //                     className="cma-image"
                            //                 />
                            //             </Grid>
                            //             <Grid item xs={7} className="cma-content">
                            //                 <Typography variant="h5">{report.title}</Typography>
                            //                 {/* Modify the below fields as per your data */}
                            //                 <Typography variant="body2">Address: {report.home.address}</Typography>
                            //                 <Typography variant="body2">Client: {report.client}</Typography>
                            //             </Grid>
                            //         </Grid>
                            //         <Grid container className="cma-actions">
                            //             <Grid item xs={5}>
                            //                 <Button variant="contained" color="primary" className="cma-edit-btn" sx={{ borderRadius: '50px' }}>Edit</Button>
                            //             </Grid>
                            //             <Grid item xs={7}>
                            //                 <Button variant="contained" className="cma-export-btn">Export</Button>
                            //             </Grid>
                            //         </Grid>
                            //     </Card>
                            // </Grid>
                            <Grid item xs={12} md={4} key={report.title}>
                                <Card className="cma-card">
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <CardMedia
                                                component="img"
                                                alt={report.title}
                                                height="180" // Increase height
                                                image={report.image}
                                                title={report.title}
                                                className="cma-image"
                                            />
                                        </Grid>
                                        <Grid item xs={12} className="cma-content">
                                            <Typography variant="h5">{report.title}</Typography>
                                            <Typography variant="body2" className="report-details">Address: {report.home.address}</Typography>
                                            <Typography variant="body2" className="report-details">Client: {report.client}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container className="cma-actions" spacing={2}>
                                        <Grid item xs={6}>
                                            <Button variant="contained" color="primary" fullWidth className="cma-edit-btn">Edit</Button>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Button variant="outlined" fullWidth className="cma-export-btn">Export</Button>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>

                        ))}
                    </Grid>
                </Grid>
            </>}
        </Container>

    );
};

export default SmartReportPage;
